import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './GiantsAutoSupplyToggle.css'
import {giantsToggleAutoAdditionalSupply} from "../../../redux/actions";
import {
  selectCurrentPlayer,
  selectGameType,
  selectPlayers,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {selectUserId} from "../../../redux/reducers/privateStateReducer/selectors";
import {getActingPlayer} from "../../../utils/players/getActingPlayer";
import {useIsCurrentUserTurn} from "../../../utils/gameState/user/useIsCurrentUserCurrentPlayer";
import {checkIfPlayerHasUnitOfFaction} from "../../../utils/factions/checkIfPlayerHasUnitOfFaction";
import {FACTIONS} from "../../../constants/factions";
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import {selectIsParallelSupplyPhase} from "../../../utils/gameState/supply/parallelSupplySelectors";
import {GameButton} from "../../gameUi/GameButton";
import {joinClassNames} from "../../gameUi/joinClassNames";

// Персональный тумблер игрока-великана, управляющий его АВТО-раздачей снабжения
// (executePhaseAutoActions/боты) - на ручной сбор доп. снабжения кликами по
// фермам (GiantsSupplyToolbar) не влияет. Виден только самому играющему за
// великанов (не всем игрокам) и не привязан к фазе - его нужно успеть
// выставить ДО начала своей фазы снабжения, где алгоритм срабатывает мгновенно
const GiantsAutoSupplyToggle = () => {
  const dispatch = useDispatch();
  const gameType = useSelector(selectGameType);
  const userId = useSelector(selectUserId);
  const isCurrentUserTurn = useIsCurrentUserTurn();
  const currentPlayer = useSelector(selectCurrentPlayer);
  const players = useSelector(selectPlayers);
  const units = useSelector(selectUnits);
  const isParallelSupplyPhase = useSelector(selectIsParallelSupplyPhase);

  const actingPlayer = getActingPlayer(gameType, userId, players, currentPlayer);

  if (!isCurrentUserTurn || !checkIfPlayerHasUnitOfFaction(actingPlayer, FACTIONS.GIANTS, units)) {
    return null;
  }

  const isOn = Boolean(actingPlayer.isGiantsAutoAdditionalSupplyOn);

  const handleClick = () => {
    // В одновременной фазе снабжения ходят все разом, и «текущий игрок» —
    // не тот, кто нажал: тумблер переключается за действующего игрока явно
    dispatch(giantsToggleAutoAdditionalSupply(isParallelSupplyPhase ? actingPlayer.id : undefined));
    REGISTRY_SINGLETON.getSoundManager().playSideMenuClick();
  };

  // Кнопка-переключатель дизайн-системы матча: включенная — вдавлена и с
  // горящим огоньком «ВКЛ», выключенная — поднята, огонек погашен
  return (
    <GameButton
      pressed={isOn}
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
      }}
      className={joinClassNames('giants-auto-supply-toggle', isOn && 'giants-auto-supply-toggle_on')}
      title={isOn
        ? 'Авто-снабжение: помимо базового, великаны копят доп. снабжение за 4 фермы (кроме самого крупного отряда - фермам сначала хватает только на базовое)'
        : 'Авто-снабжение: все фермы дают только базовое снабжение, поровну между великанами'}
    >
      <span className={'giants-auto-supply-toggle_label'}>Авто доп.</span>
      <img
        className={'giants-auto-supply-toggle_icon'}
        src={'/img/icons/supply.png'}
        alt={'снабжение'}
      />
      <span className={'giants-auto-supply-toggle_state'}>
        <span className={'giants-auto-supply-toggle_lamp'} aria-hidden={true}/>
        {isOn ? 'ВКЛ' : 'ВЫКЛ'}
      </span>
    </GameButton>
  );
};

export default GiantsAutoSupplyToggle;
